// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallGenericEmptyState {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
}
.SmallGenericEmptyState-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 315px;
  text-align: center;
}
.SmallGenericEmptyState-content p {
  color: #4c5567;
  color: var(--color_neutral_800, #4c5567);
  font-size: 14px;
  font-weight: 400;
  line-height: 150%; /* 21px */
}`, "",{"version":3,"sources":["webpack://./src/pages/TerritoryPage/components/SmallGenericEmptyState/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACI;EACE,cAAA;EAAA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AACN","sourcesContent":[".SmallGenericEmptyState {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  align-items: center;\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 315px;\n    text-align: center;\n\n    p {\n      color: var(--color_neutral_800, #4c5567);\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 150%; /* 21px */\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
